import type { DispatchRecordStatus } from '@rematter/frontend-lib-api-client';
import { atomWithDebounce } from '@rematter/ui-web';
import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { retryDispatchRecordMutationAtom } from '../_graphql/mutationDispatchRecordRetry';
import type { DispatchRecordEntry } from '../_graphql/queryDispatchRecords';
import { queryDispatchRecordsAtom } from '../_graphql/queryDispatchRecords';

import type { QueryAtomReadValue } from '~/shared/providers/api/createQueryAtomFactory';

export const $dispatchRecordSearchTerm = atomWithDebounce('', 300);
export const $dispatchRecordStatusFilter = atom<DispatchRecordStatus[]>([]);
export const $dispatchRecordConfigFilter = atom<string | undefined>(undefined);

export const $rawDispatchRecords = queryDispatchRecordsAtom((get) => {
  const statusFilter = get($dispatchRecordStatusFilter);
  const configFilter = get($dispatchRecordConfigFilter);

  return {
    variables: {
      governmentReportingConfigurationId: configFilter,
      status: statusFilter.length > 0 ? statusFilter : undefined,
    },
  };
});

export const $dispatchRecords: Atom<QueryAtomReadValue<DispatchRecordEntry[]>> =
  atom((get) => {
    const raw = get($rawDispatchRecords);
    const searchTerms = get($dispatchRecordSearchTerm.debouncedValue)
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    const data = (raw.data ?? []).filter((record) => {
      if (searchTerms.length === 0) return true;
      const searchable = [
        record.facilityName,
        record.configName,
        record.serviceType,
        record.status,
        record.batchId,
        record.errorMessage,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return searchTerms.every((term) => searchable.includes(term));
    });

    return { ...raw, data };
  });

export const $retryDispatchRecord = retryDispatchRecordMutationAtom({
  onSuccess: (get) => {
    get($rawDispatchRecords).refetch?.();
  },
});
